<template>
  <vs-row vs-justify="center" id="business-box">
    <vs-col type="flex" vs-lg="12" vs-xs="12">
      <vs-card id="form">
        <vs-tabs :value="activeTab">
          <vs-tab :label="$t('Mobile.Title')" icon="lock" id="permissions-tab">
            <vs-card class="mt-2">
              <h4>{{$t('Mobile.Home')}}:</h4>
              <vs-row class="mt-4" style="align-items: center;">
                <vs-col vs-w="6">
                  <vs-checkbox class="justify-content-start" color="primary" v-model="settings.home_organizations" >
                    <b class="ml-2">{{$t('Mobile.Organizations')}}</b>
                  </vs-checkbox>
                </vs-col>
                <vs-col vs-w="6">
                  <vs-checkbox class="justify-content-start" color="primary" v-model="settings.home_categories" >
                    <b class="ml-2">{{$t('Mobile.Industries')}}</b>
                  </vs-checkbox>
                </vs-col>
              </vs-row>

              <vs-row class="mt-4" style="align-items: center;">
                <vs-col vs-w="6">
                  <vs-checkbox class="justify-content-start" color="primary" v-model="settings.home_closest_appointment" >
                    <b class="ml-2">{{$t('Mobile.ClosestAppointments')}}</b>
                  </vs-checkbox>
                </vs-col>
                <vs-col vs-w="6">
                  <vs-checkbox class="justify-content-start" color="primary" v-model="settings.home_recommended" >
                    <b class="ml-2">{{$t('Mobile.Recommendations')}}</b>
                  </vs-checkbox>
                </vs-col>
              </vs-row>

            </vs-card>
            <div class="btn-alignment mt-4">
              <vs-button color="primary" v-on:click="updateSettings()">{{$t('Company.UpdateButton')}}</vs-button>
            </div>
          </vs-tab>
        </vs-tabs>
      </vs-card>
    </vs-col>


  </vs-row>
</template>

<script>
import { mobileService, businessService} from '../../_services'
export default {
  name: "MobileSettings",
  data: () => ({
    title: "MobileSettings",
    activeTab: 1,
    settings: {
    	home_organizations: false,
        home_categories: false,
        home_closest_appointment: false,
        home_recommended: false
    }
  }),
  methods: {
    notify(title, text, type) {
      this.$vs.notify({
        color: type,
        title: title,
        text: text
      });
    },
    showLoading(){
      this.$vs.loading({
        container: '#business-box',
        scale: 0.6
      });
    },
    hideLoading(){
      this.$vs.loading.close('#business-box > .con-vs-loading')
    },

    updateSettings(){
      const self= this;
      this.showLoading();
      let settings = new FormData();
      settings.append('id', this.settings.id);
      settings.append('home_organizations', this.settings.home_organizations);
      settings.append('home_categories', this.settings.home_categories);
      settings.append('home_closest_appointment', this.settings.home_closest_appointment);
      settings.append('home_recommended', this.settings.home_recommended);

      settings.append('_method', 'POST');

      mobileService.updateSettings(settings).then(function(data){
        self.notify(self.$t('Toasts.Successful'), self.$t('Company.EditBasic.ToastSuccess'), 'success');
        self.hideLoading();
      }).catch(function () {
        self.notify(self.$t('Toasts.Error'), self.$t('Company.EditBasic.ToastFail'), 'danger');
        self.hideLoading();
      });
    },
  },

  mounted(){
    const self = this;

    mobileService.getSettings().then(function(data){
        console.log('Mobile Settings:')
        console.log(data.mobile_settings)
        self.settings= data.mobile_settings;
    });
  }
};
</script>
